<template>
  <main :class="!showTest ? 'container' : 'container-new'">
    <div v-if="showTest === null">LOADING...</div>
    <ShortSummaryControl
      v-if="!showTest"
      data-testid="short-summary-control"
    ></ShortSummaryControl>
    <ShortSummaryTest
      v-else-if="showTest"
      data-testid="short-summary-test"
    ></ShortSummaryTest>
  </main>
</template>
<script>
import { defineComponent } from "vue";
import ShortSummaryControl from "@/components/ShortSummaryControl.vue";
import ShortSummaryTest from "@/components/ShortSummaryTest.vue";
import { mapGetters } from "vuex";

export default defineComponent({
  components: { ShortSummaryTest, ShortSummaryControl },
  computed: {
    ...mapGetters({
      showTest: "getEditFlowTest",
    }),
  },
  beforeCreate() {
    // Show loading panel immediately to prevent flashing issues from new A/B test.
    this.$store.commit("SHOW_LOADING_PANEL");
  },
});
</script>

<style lang="scss" scoped>
.container-new {
  display: flex;
  width: 1000px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;

  @include media("<large") {
    width: auto;
    align-items: normal;
  }
}
</style>
